import { __assign } from '../node_modules/tslib/tslib.es6.js';
import { BRANDCLUB_BRAND_ID } from './constants/Constants.js';
import { isParentProduct } from './stringUtils.js';

var BRANDCLUB_LOGO_URL = 'https://media.brandclub.com/brandclub/image_asset/brandclub-b-logo.webp';
var BC_MEDIA_DOMAIN = 'https://media.brandclub.com';
var BC_VIDEOS = {
    HOME_HEAD: {
        video: 'https://media.brandclub.com/brandclub/media/home_head.mp4',
        coverImage: 'https://media.brandclub.com/brandclub/media/cover/home_head.png',
    },
    DAVID: {
        video: 'https://media.brandclub.com/brandclub/media/video_david.mp4',
        coverImage: 'https://media.brandclub.com/brandclub/media/cover/video_david.png',
    },
    JESSICA: {
        video: 'https://media.brandclub.com/brandclub/media/video_jessica.mp4',
        coverImage: 'https://media.brandclub.com/brandclub/media/cover/video_jessica.png',
    },
    EMMA: {
        video: 'https://media.brandclub.com/brandclub/media/video_emma.mp4',
        coverImage: 'https://media.brandclub.com/brandclub/media/cover/video_emma.png',
    },
    ANGELA: {
        video: 'https://media.brandclub.com/brandclub/media/video_angela.mp4',
        coverImage: 'https://media.brandclub.com/brandclub/media/cover/video_angela.png',
    },
    MARCUS: {
        video: 'https://media.brandclub.com/brandclub/media/video_marcus.mp4',
        coverImage: 'https://media.brandclub.com/brandclub/media/cover/video_marcus.png',
    },
};
var BC_TESTIMONIALS = [
    __assign(__assign({}, BC_VIDEOS.DAVID), { name: 'David R.', location: 'Minneapolis, MN', testimonial: "\u201CI can now earn cash back for purchases at Amazon, Walmart and Target.\u201D" }),
    __assign(__assign({}, BC_VIDEOS.JESSICA), { name: 'Jessica P.', location: 'Dallas, TX', testimonial: "\u201CI can earn cash back whenever I shop online or in my favorite stores.\u201D" }),
    __assign(__assign({}, BC_VIDEOS.EMMA), { name: 'Emma S.', location: 'Phoenix, AZ', testimonial: "\u201CBrandclub has an amazing affiliate program where I can earn up to 20% commission.\u201D" }),
    __assign(__assign({}, BC_VIDEOS.ANGELA), { name: 'Angela W.', location: 'Chicago, Il.', testimonial: "\u201CBrandclub allows me to earn cash back for the items that are always in my shopping cart.\u201D" }),
    __assign(__assign({}, BC_VIDEOS.MARCUS), { name: 'Marcus H.', location: 'Boston, MA', testimonial: "\u201CI can easily compare prices across Chewy, Amazon and other retailers.\u201D" }),
];
var getImageAssetUrl = function (fileName, relativePath, domain) {
    if (relativePath === void 0) { relativePath = 'brandclub/image_asset'; }
    if (domain === void 0) { domain = BC_MEDIA_DOMAIN; }
    return "".concat(domain, "/").concat(relativePath, "/").concat(fileName);
};
var getAssetNameFromUrl = function (fileUrl) {
    var arr = fileUrl.split('/');
    if (arr.length > 0) {
        return arr[arr.length - 1];
    }
    return '';
};
var getEntityImage = function (id, type, subId) {
    if (type === 'retailer') {
        return "https://media.brandclub.com/retailer_logo/".concat(subId !== null && subId !== void 0 ? subId : id, ".webp");
    }
    if (type === 'brand' && +id === 50000) {
        return BRANDCLUB_LOGO_URL;
    }
    if (isParentProduct("".concat(id))) {
        return "https://s3-us-west-2.amazonaws.com/stackline-product-images/parent-products/".concat(id, ".jpg");
    }
    return "https://s3-us-west-2.amazonaws.com/stackline-product-images/".concat(id, ".jpg");
};
var getDefaultProductImage = function (stacklineSku) {
    return "https://media.brandclub.com/p/428x428/".concat(isParentProduct(stacklineSku) ? 'parent-products/' : '').concat(stacklineSku, ".jpg");
};
var getFallbackProductImage = function (stacklineSku) {
    return "https://media-api.brandclub.com/p/428x428/".concat(isParentProduct(stacklineSku) ? 'parent-products/' : '').concat(stacklineSku, ".jpg");
};
var getBrandLogo = function (brandId) {
    if (brandId === BRANDCLUB_BRAND_ID) {
        return getImageAssetUrl("".concat(brandId, ".svg"), 'b/428x428');
    }
    return getImageAssetUrl("".concat(brandId, ".jpg"), 'b/428x428');
};

export { BC_MEDIA_DOMAIN, BC_TESTIMONIALS, BC_VIDEOS, getAssetNameFromUrl, getBrandLogo, getDefaultProductImage, getEntityImage, getFallbackProductImage, getImageAssetUrl };
//# sourceMappingURL=assetUtils.js.map
